import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const EyePencilIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 22 20"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 20)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10.999 13.121c-3.645.063-7.34-2.526-9.62-5.063a1.502 1.502 0 0 1 0-1.999C3.71 3.47 7.416.94 11 1.001c3.583-.06 7.289 2.47 9.621 5.058a1.502 1.502 0 0 1 0 2" />
      <path d="M14.332 7.062c0 .667-.195 1.318-.562 1.871a3.341 3.341 0 0 1-1.495 1.24 3.301 3.301 0 0 1-3.633-.73 3.401 3.401 0 0 1-.723-3.67 3.36 3.36 0 0 1 1.228-1.512 3.309 3.309 0 0 1 4.21.419 3.371 3.371 0 0 1 .976 2.382ZM20.17 12.624l-5.627 5.663-2.814.596.592-2.832 5.628-5.662a1.605 1.605 0 0 1 2.221 0v0a1.492 1.492 0 0 1 .5 1.118 1.501 1.501 0 0 1-.5 1.117v0Z" />
      <path
        transform="scale(.99688 1.00311) rotate(45 -5.398 26.372)"
        d="M0-.75h2.883"
      />
    </SVG>
  );
};
